import { charts } from '@components/shared/CampaignAnalytics/ChartDefinitions/chartDefinitions';
import Loading from '@components/shared/Loading';
import { Alert, Box, BoxProps, Stack } from '@mui/material';
import { useCurrentLatestCampaignAnalyticsReport } from './hooks/useCampaignAnalytics';
import { useMemo } from 'react';

type CampaignAnalyticsProps = {
  contentProps?: BoxProps;
  campaignName: string;
  campaignId: number;
};

const CampaignAnalytics = (props: CampaignAnalyticsProps) => {
  const { report, error, isLoading } =
    useCurrentLatestCampaignAnalyticsReport();
  const { campaignName, campaignId } = props;
  const memoizedCharts = useMemo(() => {
    return charts.map(chart => {
      const { id: chartId, ChartComponent } = chart;

      if (!report?.[chartId].visible || !campaignName || !campaignId)
        return null;

      return (
        <ChartComponent
          key={chartId}
          editable={false}
          report={report}
          campaignName={campaignName}
          campaignId={campaignId}
        />
      );
    });
  }, [report, campaignName, campaignId]);

  const pageContent = () => {
    if (isLoading) return <Loading />;

    if (error)
      return (
        <Alert severity="error">Error loading campaign analytics report.</Alert>
      );

    if (
      !report ||
      charts.filter(chart => report[chart.id].visible).length === 0
    )
      return (
        <Alert severity="info">
          No data available for selected report date.
        </Alert>
      );

    return (
      <Stack direction="column" spacing={2}>
        {memoizedCharts}
      </Stack>
    );
  };

  return (
    <Box padding={2} {...props.contentProps}>
      {pageContent()}
    </Box>
  );
};

export default CampaignAnalytics;
